import anime from "animejs";

export default class Accordion {
  constructor() {
    this._accordion = document.querySelectorAll(".jsAccordionHead");
    if (this._accordion.length > 0) this.init();
  }

  openAccordion(i, h, arr) {
    // open accordion
    anime({
      targets: i,
      height: h,
      easing: "easeInSine",
      duration: 200
    });

    // rotate arrow
    anime({
      targets: arr,
      rotate: "180deg"
    });
  }

  closeAccordion(i, arr) {
    // close accordion
    anime({
      targets: i,
      height: 0,
      easing: "easeInSine",
      duration: 200
    });

    // rotate arrow
    anime({
      targets: arr,
      rotate: 0
    });
  }

  init() {
    let l = this._accordion.length;
    for (let i = 0; i < l; i++) {
      let a = this._accordion[i];

      a.addEventListener("click", () => {
        if (a.classList.contains("active")) {
          this.closeAccordion(
            a.parentElement.querySelector(".jsAccordionBody"),
            a.parentElement.querySelector(".jsAccordionArr")
          );
        } else {
          this.openAccordion(
            a.parentElement.querySelector(".jsAccordionBody"),
            a.parentElement.querySelector(".jsAccordionContent").offsetHeight,
            a.parentElement.querySelector(".jsAccordionArr")
          );
        }

        a.classList.toggle("active");
      });
    }
  }
}
